import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import Card from 'react-bootstrap/Card';
import Header from './header';
import Pane from './pane';
import FundContext from './context';
import DataReviewModal from './data-review-modal';

const Body = styled(Card.Body)`
  > a {
    margin-right: 20px;
  }
`;

export default function DataReviews() {
  const { state: { fund }, dispatch } = React.useContext(FundContext);

  const show = payload => e => {
    e && e.preventDefault();
    dispatch({ type: 'showDataReviewModal', payload });
  };

  return (
    <Card>
      <Card.Header>
        <Header eventKey="data-reviews">Data Reviews</Header>
      </Card.Header>
      <Pane eventKey="data-reviews">
        <Body>
          {fund.dataReviews.map(review => (
            <a
              href="#"
              key={review.createdAt}
              onClick={show(review)}
            >
              {moment(review.createdAt).format('DD/MM/YY @ h.mma')}
            </a>
          ))}
        </Body>
        <DataReviewModal context={FundContext} />
      </Pane>
    </Card>
  );
}
